import React, { useContext } from 'react';
// import { HiOutlinePlusCircle } from 'react-icons/hi';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import { PropsFromRedux } from '.';
import { ReactComponent as AddReceiver } from '../../../../assets/images/adduser-green.svg';
import { ReactComponent as Receiver } from '../../../../assets/images/receiver-user.svg';
import PersonalShopperContext from '../../../../context/PersonalShopperContex/PersonalShopperContex';
import styles from './ReceiverList.module.scss';

interface Props extends PropsFromRedux {}


const ReceiverList: React.FC<Props> = ({ 
    hideModal,
    showModal,
    modal,
    receiverState
 }) => {

    const history = useHistory();
    const location = useLocation();

    const receiverList = receiverState?.response?.Object;
    const { shopperData, setShopperData } = useContext(PersonalShopperContext);
    const [ addreceiver, setReceiver ] = React.useState({})
    const modalProps = modal?.ownProps?.changereceiver;

    // console.log('Receiver List ',receiverList);


    const closeModal = () => {
        hideModal();
    }

    // console.log('modal props',modalProps);

    const selectedReceiver = (selected : any) => {
        // console.log(selected);
        setReceiver(selected);
        // console.log()
        if(modalProps == 'updatereceiver'){
            // console.log('okay i am here', shopperData?.ShoppingItem);
            shopperData.Receiver = selected;
            shopperData.ReceiverDetails = selected;
            history.push({
            pathname : '/personal-shoppingforms/itemdetails',
            state : { data : selected}
            })
            hideModal();
        }

        if(modalProps == 'addreceiver'){
            // console.log('okay i am here', shopperData?.ShoppingItem);
            shopperData.AddReceiver = selected;
            shopperData.ReceiverDetails = selected;
            history.push({
            pathname : '/personal-shoppingforms/add-item',
            state : { data : selected}
            })
            hideModal();
        }
        // if( shopperData?.ShoppingItem && shopperData?.ShoppingItem.length >= 1){  
        // }
        
    }

    // console.log('shopping details',shopperData);
    // console.log('shopping details',shopperData?.ShoppingItem);

    return(
        <div className="w-full px-2 bg-white lg:px-20 py-10 relative">
            <button type="button" aria-label="Close" onClick={closeModal}>
             <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
          </button>
          <div className="w-full">
            <div className="w-full mt-6 my-2">
                    <div className={`w-69 p-2 flex justify-between rounded-md ${styles.greenbg}`}>
                        <div className="p-2 inline-flex">
                             <AddReceiver className="inline-flex w-12 mr-3" />
                            <h5 className="font-semibold text-white mt-3">Add New Receiver</h5>
                        </div>
                    </div>
                </div>
                {receiverList?.map((receiver : any) => ( 
                    <button type="button" key={receiver.id} className="w-full p-4 border border-grey-300 rounded-sm my-2"  onClick={() => selectedReceiver(receiver)}  >
                       <div className="flex justify-between">
                           <Receiver className="" />
                           <div className="mx-2">
                               <h5 className="font-medium text-sm font-semibold">{receiver.FullName}</h5>
                               <p className="text-gray-400 text-xs my-2 w-56">{receiver.Address}</p>
                           </div>
                           <p className="mt-7 text-xs text-gray-400">{receiver.PhoneNumber}</p>
                       </div>
               </button>
                ))}
          </div>
        </div>
     );
};

export default ReceiverList;